import { render, staticRenderFns } from "./SkeletonItem.vue?vue&type=template&id=269c0fc6"
import script from "./SkeletonItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports